// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.0.1",
  date: "2026-06-05T13:52:12.226Z",
  gitInfo: {
    dirty: false,
    raw: "1ad45bd68",
    hash: "1ad45bd68",
    distance: null,
    tag: null,
    semver: null,
    suffix: "1ad45bd68",
    semverString: null
  }
};
/* tslint:enable */
